export const projectIsRemove: (teamState: 0 | 1, temMemberState: 0 | 1) => boolean = (
	teamState,
	temMemberState,
) => {
	if (teamState === 0 || temMemberState === 0) {
		return true;
	} else {
		return false;
	}
};
